<template>
  <div ref="component" class="cubeSpace home-section">
    <section class="ancho grid-efi">
      
      <aside>
        <h1 class="fuente-posm">Tecnología que se adapta a cada espacio.</h1>
        <button class="button-outline font- hover-boton_mod fuente-nova2 btn-descubre" @click="openContactModal">
          Descubre Cómo
        </button>
      </aside>

      <aside class="aside-figure">
        <transition name="hero-slide" mode="out-in">
          <div
            class="hero-image"
            :key="'hero-' + heroIndex"
            :style="{ backgroundImage: `url(${heroSlides[heroIndex].image})` }"
          >
            <!-- Notificación flotante -->
            <transition name="notification-pop">
              <div class="notification-card" v-if="showNotification" :key="'notif-' + heroIndex">
                <div class="notification-icon">
                  <img :src="heroSlides[heroIndex].logo" :alt="heroSlides[heroIndex].name">
                </div>
                <div class="notification-content">
                  <strong>{{ heroSlides[heroIndex].name }}</strong>
                  <p>{{ heroSlides[heroIndex].message }}</p>
                </div>
              </div>
            </transition>
          </div>
        </transition>
        <p class="fuente-posm">{{ heroSlides[heroIndex].tagline }}</p>
      </aside>

    </section>
  </div>
  
  <ContactModal />
</template>

<script>
import ContactModal from '@/components/modal/Contact.vue'

export default {
  components: { ContactModal },
  name: "page1",
  emits: ["sendAction"],
  
  props: {
    action: {
      type: Object,
      default: () => {},
    },
    pos: {
      type: Number,
      default: 0,
    },
  },

  data() {
    return {
      // Carrusel Social Proof
      currentIndex: 0,
      intervalId: null,

      // Carrusel Hero
      heroIndex: 0,
      heroIntervalId: null,
      showNotification: false,
      notificationTimeoutId: null,

      heroSlides: [
        {
          image: require('@/assets/images/Fotos Web Proactive/carrusel/lasbrisas2.jpg'),
          logo: require('@/assets/images/Fotos Web Proactive/logobrisasblanco1.png'),
          name: 'Brisas Wayam',
          message: 'Automatización de iluminación, cerraduras electrónicas y WiFi certificados LEED.',
          tagline: 'Tecnología que se integra.'
        },
        {
          image: require('@/assets/images/Fotos Web Proactive/carrusel/boyance2.jpg'),
          logo: require('@/assets/images/Fotos Web Proactive/logoboyance.png'),
          name: 'Boyance',
          message: 'Una cabaña de concreto conectada por voz, datos, audio y automatización. Sin un solo apagador.',
          tagline: 'Diseño que desaparece.'
        },
        {
          image: require('@/assets/images/Fotos Web Proactive/bostons1.jpg'),
          logo: require('@/assets/images/Fotos Web Proactive/logobpicono.png'),
          name: "Boston's Pizza",
          message: 'Red de datos y servidores unificados en más de 20 sucursales y su callcenter.',
          tagline: 'Operación sin interrupciones.'
        },
        {
          image: require('@/assets/images/Fotos Web Proactive/trenmaya.jpg'),
          logo: require('@/assets/images/Fotos Web Proactive/logotrenmaya.png'),
          name: 'Tren Maya',
          message: 'Ingeniería tecnológica completa: voz, datos, video IP y audio para el proyecto de infraestructura más importante del sureste.',
          tagline: 'A la escala que necesitas.'
        },
        {
          image: require('@/assets/images/Fotos Web Proactive/carrusel/kancabchen1.jpg'),
          logo: require('@/assets/images/Fotos Web Proactive/logokancabchen.png'),
          name: 'Hacienda Kancabchen',
          message: 'Red GPON de varios kilómetros conectando múltiples sitios y servicios de todo el complejo.',
          tagline: 'Sin límites de distancia.'
        },
        {
          image: require('@/assets/images/Fotos Web Proactive/carrusel/reef2.jpg'),
          logo: require('@/assets/images/Fotos Web Proactive/logoreef.png'),
          name: 'Reef Club',
          message: 'Llevamos internet a un hotel de 30 años usando su red de ductos existente, sin interrumpir operaciones.',
          tagline: 'Inteligencia sobre lo que ya existe.'
        },
      ],

      partners: [
        {
          name: 'Sonos',
          logo: require('@/assets/images/Fotos Web Proactive/logosonos.png'),
          description: 'Partner certificado. Diseñamos e instalamos sistemas de audio de la más alta calidad para espacios residenciales, hoteleros y comerciales.'
        },
        {
          name: 'Ubiquiti / Unifi',
          logo: require('@/assets/images/Fotos Web Proactive/logoubiquiti.png'),
          description: 'Partner oficial. Infraestructura de red empresarial y videovigilancia IP de clase mundial para proyectos de cualquier escala.'
        },
        {
          name: 'Wulian',
          logo: require('@/assets/images/Fotos Web Proactive/logowulian.png'),
          description: 'Partner certificado en automatización inteligente. Controlamos iluminación, accesos, clima y más desde un solo ecosistema.'
        },
        {
          name: "Boston's Pizza",
          logo: require('@/assets/images/Fotos Web Proactive/logobpicono.png'),
          description: 'Red de datos y servidores unificada en más de 20 sucursales a nivel nacional y su callcenter corporativo.'
        },
        {
          name: 'Brisas Wayam',
          logo: require('@/assets/images/Fotos Web Proactive/logobrisasblanco1.png'),
          description: 'Hotel boutique con Certificación LEED Premium. Desarrollamos todas las áreas tecnológicas: WiFi, automatización, cerraduras electrónicas y videovigilancia.'
        },
        {
          name: 'IETram',
          logo: require('@/assets/images/Fotos Web Proactive/logoietram (Editado).png'),
          description: 'Patio de encierro del sistema de transporte urbano. Diseñamos la red de fibra óptica GPON que provee datos a todo el proyecto y los pantógrafos de los autobuses.'
        },
        {
          name: 'Catvi / Tren Maya',
          logo: require('@/assets/images/Fotos Web Proactive/logotrenmaya.png'),
          description: 'Diseño completo del proyecto de ingeniería tecnológica: voz, datos, video IP y audio.'
        },
        {
          name: 'Hacienda San Antonio Hool',
          logo: require('@/assets/images/Fotos Web Proactive/proactivelogonegro.png'),
          description: 'Chapas electrónicas que conectan sofisticación, tecnología y el diseño ancestral de la hacienda.'
        },
        {
          name: 'Reef Club',
          logo: require('@/assets/images/Fotos Web Proactive/logoreef.png'),
          description: 'Internet de alta velocidad a un hotel con 30 años de antigüedad usando la red de ductos existente, sin interrumpir operaciones.'
        },
        {
          name: 'Holos',
          logo: require('@/assets/images/Fotos Web Proactive/proactivelogonegro.png'),
          description: 'Clínica oftalmológica de alta especialidad. Red de alta velocidad para compartir estudios e información de pacientes entre todos los equipos.'
        },
        {
          name: 'UNAY',
          logo: require('@/assets/images/Fotos Web Proactive/proactivelogonegro.png'),
          description: 'Universidad de las artes de Yucatán. Red de la nueva área de artes digitales: flexible, escalable y lista para el futuro.'
        },
        {
          name: 'Hacienda Kancabchen',
          logo: require('@/assets/images/Fotos Web Proactive/logokancabchen.png'),
          description: 'Red GPON de varios kilómetros conectando todos los puntos y servicios del complejo.'
        },
        {
          name: 'Residencias Premium',
          logo: require('@/assets/images/Fotos Web Proactive/proactivelogonegro.png'),
          description: 'Múltiples residencias en Centro Histórico y Yucatán Country Club integradas para una vida completamente conectada.'
        },
      ],
    };
  },

  watch: {
    action: {
      handler() {
        this.getAction();
      },
      deep: true,
    },
  },

  mounted() {
    this.getComponentHeight();
    this.startCarousel();
    this.startHeroCarousel();
  },

  beforeUnmount() {
    this.stopCarousel();
    this.stopHeroCarousel();
  },

  methods: {
    startCarousel() {
      this.intervalId = setInterval(() => {
        this.nextSlide();
      }, 6000); /* ORIGINAL: 4000 - reversible */
    },

    stopCarousel() {
      if (this.intervalId) {
        clearInterval(this.intervalId);
        this.intervalId = null;
      }
    },

    nextSlide() {
      /* ORIGINAL: this.currentIndex = (this.currentIndex + 1) % this.partners.length; - reversible */
      let newIndex;
      do {
        newIndex = Math.floor(Math.random() * this.partners.length);
      } while (newIndex === this.currentIndex);
      this.currentIndex = newIndex;
    },

    // ========== Hero Carousel Methods ==========
    getRandomInterval() {
      // Retorna un tiempo aleatorio entre 12 y 16 segundos
      return Math.floor(Math.random() * 4000) + 12000; // 12000-16000ms
    },

    getRandomIndex() {
      // Retorna un índice aleatorio diferente al actual
      let newIndex;
      do {
        newIndex = Math.floor(Math.random() * this.heroSlides.length);
      } while (newIndex === this.heroIndex);
      return newIndex;
    },

    startHeroCarousel() {
      // Mostrar notificación inicial después de 1 segundo
      this.notificationTimeoutId = setTimeout(() => {
        this.showNotification = true;
      }, 1000);

      // Programar el primer cambio con tiempo aleatorio
      this.scheduleNextHeroSlide();
    },

    scheduleNextHeroSlide() {
      const randomTime = this.getRandomInterval();
      this.heroIntervalId = setTimeout(() => {
        this.nextHeroSlide();
      }, randomTime);
    },

    stopHeroCarousel() {
      if (this.heroIntervalId) {
        clearTimeout(this.heroIntervalId);
        this.heroIntervalId = null;
      }
      if (this.notificationTimeoutId) {
        clearTimeout(this.notificationTimeoutId);
        this.notificationTimeoutId = null;
      }
    },

    nextHeroSlide() {
      // 1. Ocultar notificación (animación dura 0.6s)
      this.showNotification = false;

      // 2. Después de que sale la notificación, cambiar imagen
      setTimeout(() => {
        this.heroIndex = this.getRandomIndex(); // Orden aleatorio

        // 3. Después de que entra la imagen (1.2s), mostrar notificación
        setTimeout(() => {
          this.showNotification = true;
          // 4. Programar siguiente slide con tiempo aleatorio
          this.scheduleNextHeroSlide();
        }, 1400);
      }, 700);
    },

    openContactModal() {
      const modalEl = document.getElementById('contactModal');
      if (modalEl) {
        import('bootstrap').then(({ Modal }) => {
          const contactModal = new Modal(modalEl);
          contactModal.show();
        });
      }
    },

    getComponentHeight() {
      let component = this.$refs.component;
      this.$emit("sendAction", {
        action: "setHeight",
        data: { pos: this.pos, val: component.offsetHeight },
      });
    },

    getAction() {
      switch (this.action?.type) {
        case "?":
          break;
      }
    },
  },
};
</script>

<style lang="css" scoped>
.cubeSpace {
  overflow: hidden;
  width: 100vw;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
}

.grid-efi {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-template-rows: 1fr auto; /* NUEVO - contenido arriba, carrusel abajo */
  place-items: center;
  width: 100%;
  max-width: 1800px;
  height: 100%; /* NUEVO - altura completa */
  padding: 0 2%; /* ORIGINAL: sin padding - reversible */
}

.grid-efi aside {
  max-width: 800px;
  height: auto;
  margin: 15px;
}

.grid-efi aside:first-child {
  justify-self: start; /* NUEVO - alinea el aside del título a la izquierda */
  margin-left: 0; /* NUEVO - quita margen izquierdo para alinear con carrusel */
}

.btn-descubre {
  margin-left: 15px; /* NUEVO - mueve botón a la derecha sin afectar título */
}

.grid-efi h1 {
  font-size: clamp(26px, 2.8vw, 45px); /* ORIGINAL: clamp(30px, 4vw, 65px) - reversible */
  line-height: 1.1;
  color: var(--color-2);
  margin-bottom: 30px;
}

.grid-efi aside figure {
  max-width: 800px;
  height: auto;
  margin: 0;
}

.grid-efi aside figure img {
  width: 100%;
}

.aside-figure {
  display: flex;
  flex-direction: column;
  justify-content: end;
  align-items: center;
  text-align: center;
  max-width: none; /* Sobreescribe el max-width de .grid-efi aside */
  width: 100%;
}

.aside-figure p {
  font-size: clamp(16px, 2vw, 35px);
  margin-top: 20px;
  color: var(--color-2);
}

/* ========== Hero Image con Notificación ========== */
.hero-image {
  position: relative;
  width: 620px; /* ORIGINAL: 550px - más ancho */
  height: 400px; /* ORIGINAL: 420px - más bajo para proporción panorámica */
  background-size: cover;
  background-position: center;
  border-radius: 24px;
  overflow: hidden;
}

.notification-card {
  position: absolute;
  bottom: 25px;
  left: 50%;
  transform: translateX(-50%); /* Centra horizontalmente */
  width: 80%; /* ORIGINAL: 70% - reversible */
  background: rgba(255, 255, 255, 0.80);
  backdrop-filter: blur(10px);
  border-radius: 30px; /* Más redondeado */
  padding: 20px 25px;
  display: flex;
  align-items: center;
  gap: 15px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
}

.notification-icon {
  width: 75px;
  height: 75px;
  border-radius: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  overflow: hidden;
}

.notification-icon img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.notification-content {
  flex: 1;
  text-align: left;
}

.notification-content strong {
  display: block;
  font-size: 18px; /* Más grande */
  color: #1a1a1a;
  margin-bottom: 2px;
}

.notification-content p {
  font-size: 15px !important; /* Más grande */
  color: #666;
  margin: 0 !important;
  line-height: 1.4;
}

/* ========== Social Proof Carrusel ========== */
.social-proof {
  display: flex;
  align-items: center;
  justify-content: flex-start; /* ORIGINAL: center - reversible */
  /* max-width: 800px; ORIGINAL - removido para alinear a la izquierda */
  grid-column: 1 / -1; /* Ocupa las 2 columnas */
  margin-top: auto; /* Empuja hacia abajo */
  padding-bottom: 4%;
  padding-left: 2%; /* NUEVO - alineado con el título, reversible */
  width: 100%;
}

.social-proof__logo {
  margin: 0; /* NUEVO - quita margen heredado del aside */
  min-width: 150px; /* NUEVO - evita brincos al cambiar logos */
  height: 60px; /* NUEVO - altura fija para evitar brincos */
  display: flex;
  align-items: center;
  justify-content: center;
}

.social-proof__logo figure {
  width: auto; /* ORIGINAL: 150px - ahora auto para ajustar al logo */
  height: 60px; /* ORIGINAL: auto - reversible */
  margin: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.social-proof__logo figure img {
  margin: 0;
  max-width: 100%;
  max-height: 60px; /* 100% del contenedor */
  width: auto;
  object-fit: contain;
}

.social-proof__text {
  width: clamp(250px, 30vw, 500px); /* NUEVO - ancho responsivo */
  max-width: none;
  margin: 0;
  min-height: 45px; /* NUEVO - altura mínima para evitar brincos */
  display: flex;
  align-items: center;
}

.social-proof__text p {
  font-size: clamp(10px, 1vw, 16px);
  margin: 0;
  color: #585858; /* NUEVO - color de texto */
}

.linea-divisor {
  height: 70px;
  width: 5px;
  background-color: #DBDBDB;
  margin: 0px 20px 0px 15px; /* ORIGINAL: 0px 20px - reducido izquierda 25% */
}

/* ========== Transiciones ========== */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s ease; /* ORIGINAL: 0.4s - reversible */
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

/* ========== Hero Slide Transition (derecha a izquierda, elegante) ========== */
.hero-slide-enter-active {
  animation: slideInFromRight 1.2s cubic-bezier(0.22, 1, 0.36, 1);
}

.hero-slide-leave-active {
  animation: slideOutToLeft 0.9s cubic-bezier(0.4, 0, 0.2, 1);
}

@keyframes slideInFromRight {
  from {
    transform: translateX(60%);
    opacity: 0;
  }
  to {
    transform: translateX(0);
    opacity: 1;
  }
}

@keyframes slideOutToLeft {
  from {
    transform: translateX(0);
    opacity: 1;
  }
  to {
    transform: translateX(-20%);
    opacity: 0;
  }
}

/* ========== Notification Pop Transition (suave y elegante) ========== */
.notification-pop-enter-active {
  animation: notificationSlideUp 0.8s cubic-bezier(0.16, 1, 0.3, 1);
}

.notification-pop-leave-active {
  animation: notificationSlideDown 0.6s cubic-bezier(0.4, 0, 0.2, 1);
}

@keyframes notificationSlideUp {
  0% {
    transform: translateX(-50%) translateY(80%);
    opacity: 0;
  }
  70% {
    transform: translateX(-50%) translateY(-4px);
    opacity: 1;
  }
  100% {
    transform: translateX(-50%) translateY(0);
    opacity: 1;
  }
}

@keyframes notificationSlideDown {
  from {
    transform: translateX(-50%) translateY(0);
    opacity: 1;
  }
  to {
    transform: translateX(-50%) translateY(60%);
    opacity: 0;
  }
}


/* ========== Responsive ========== */
@media screen and (max-width: 1280px) {
  .grid-efi {
    margin-top: 70px;
  }

  .social-proof {
    margin-top: 0px;
  }
}

@media screen and (max-width: 768px) {
  .cubeSpace {
    height: 100vh;
    padding: 0;
    overflow: hidden;
  }

  .grid-efi {
    grid-template-columns: 1fr;
    grid-template-rows: auto auto auto;
    text-align: center;
    margin-top: 0;
    padding: 0 5%;
    gap: 0;
    height: calc(100vh - 80px);
    align-content: start;
    padding-top: 20px;
  }

  .grid-efi aside:first-child {
    justify-self: center;
    order: 1;
    margin: 0 0 10px 0;
  }

  .grid-efi h1 {
    font-size: clamp(20px, 5.5vw, 28px);
    margin-bottom: 12px;
  }

  .btn-descubre {
    margin-left: 0;
  }

  .aside-figure {
    order: 2;
    width: 100%;
    margin: 0;
    justify-content: center;
  }

  .hero-image {
    width: 85vw;
    max-width: 350px;
    height: 240px;
    border-radius: 18px;
  }

  .aside-figure p {
    font-size: clamp(13px, 3.5vw, 18px);
    margin-top: 8px;
    margin-bottom: 15px;
  }

  .notification-card {
    width: 90%;
    padding: 10px 12px;
    border-radius: 18px;
    bottom: 12px;
    gap: 8px;
  }

  .notification-icon {
    width: 45px;
    height: 45px;
    border-radius: 10px;
  }

  .notification-content strong {
    font-size: 13px;
  }

  .notification-content p {
    font-size: 11px !important;
    line-height: 1.3;
  }

  .social-proof {
    order: 3;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 15px 5%;
    padding-bottom: 25px;
    gap: 8px;
  }

  .social-proof__logo {
    min-width: auto;
    height: 35px;
  }

  .social-proof__logo figure {
    height: 35px;
  }

  .social-proof__logo figure img {
    max-height: 35px;
  }

  .linea-divisor {
    width: 50px;
    height: 3px;
    margin: 5px 0;
  }

  .social-proof__text {
    width: 100%;
    max-width: 280px;
    text-align: center;
    min-height: auto;
  }

  .social-proof__text p {
    font-size: 12px;
    line-height: 1.4;
  }
}

@media screen and (max-width: 490px) {
  .grid-efi {
    margin-top: 40px;
  }

  .hero-image {
    width: 85vw;
    height: 260px;
  }

  .notification-card {
    padding: 10px 12px;
    gap: 8px;
  }

  .notification-icon {
    width: 40px;
    height: 40px;
    border-radius: 10px;
  }

  .notification-content strong {
    font-size: 13px;
  }

  .notification-content p {
    font-size: 11px !important;
  }
}
</style>